// preload.js
const cache = {templates: {},usageOrder: [] };

const TYPES = ['patterns', 'pages', 'kits'];
const TTL = 60 * 60 * 1000; //time for caching
const MAX_TYPES_CACHED = 5;

const tryStorage = () => (typeof localStorage !== 'undefined' ? localStorage : sessionStorage);

const updateLRU = (type) => {
	const index = cache.usageOrder.indexOf(type);
	if (index !== -1) cache.usageOrder.splice(index, 1);
	cache.usageOrder.unshift(type);

	if (cache.usageOrder.length > MAX_TYPES_CACHED) {
		const evict = cache.usageOrder.pop();
		delete cache.templates[evict];
		tryStorage().removeItem(`vayuCache_${evict}`);
	}
};


const trySetLocalStorage = (key, value) => {
	try {
		tryStorage().setItem(key, value);
		return true;
	} catch (e) {
		console.warn(`[vayu] Failed to store "${key}" in storage:`, e);
		return false;
	}
};

const getLocalCache = (type) => {
	try {
		const stored = tryStorage().getItem(`vayuCache_${type}`);
		if (!stored) return null;
		const parsed = JSON.parse(stored);
		if (Date.now() - parsed.timestamp < TTL) return parsed.templates;
	} catch (_) {}
	return null;
};

export const preloadTemplates = async (force = false) => {
	const apiBase = window?.wpApiSettings?.root || '/wp-json/';

	await Promise.all(
		TYPES.map(async (type) => {
			if (!force && cache.templates[type]?.length > 0) {
				updateLRU(type);
				return;
			}

			if (!force) {
				const localTemplates = getLocalCache(type);
				if (localTemplates) {
					cache.templates[type] = localTemplates;
					updateLRU(type);
					return;
				}
			}

			try {
				const res = await fetch(
					`${apiBase}vayu-blocks/v1/manifest?page=1&per_page=10&type=${type}`,
					{
						method: 'GET',
						headers: { 'X-WP-Nonce': window?.wpApiSettings?.nonce || '' },
						credentials: 'include',
					}
				);
				if (!res.ok) throw new Error(`Fetch failed for ${type}`);
				const json = await res.json();

				const list = Array.isArray(json.templates) ? json.templates : [];
				cache.templates[type] = list;
				updateLRU(type);

				trySetLocalStorage(
					`vayuCache_${type}`,
					JSON.stringify({
						templates: list,
						total: json.total || list.length,
						timestamp: Date.now(),
					})
				);
			} catch (err) {
				console.warn(`Preload failed for ${type}:`, err);
				cache.templates[type] = [];
			}
		})
	);
};

export const getPreloaded = (type = 'patterns') => {
	if (cache.templates[type]?.length > 0) {
		updateLRU(type);
		return cache.templates[type];
	}
	const localTemplates = getLocalCache(type);
	if (localTemplates) {
		cache.templates[type] = localTemplates;
		updateLRU(type);
		return localTemplates;
	}
	return [];
};

export const clearPreloadCache = () => {
	TYPES.forEach((type) => {
		cache.templates[type] = [];
		tryStorage().removeItem(`vayuCache_${type}`);
	});
	cache.usageOrder = [];
};
